export default __webpack_public_path__ + "static/media/triangulosJuntos.b4266e43.png";